// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Skyhold — every colour that carries meaning, in one place so tests/contrast.test.ts can hold it
// to WCAG 1.4.11 (≥3:1 for a non-text graphic) against every surface it can actually sit on.
//
// The governing split, and the reason the board survives colour blindness AND a greyscale
// screenshot: GEOMETRY ENCODES HEIGHT, HUE ENCODES OWNERSHIP, and neither ever does the other's
// job. The four tier faces are deliberately near-isoluminant, so counting rings — not reading a
// colour — is how you read a tower.

export const PALETTE = {
  sky: '#0B1124',
  panel: '#17203A',
  panelHi: '#222D4C',
  gutter: '#101830',

  slab0: '#CDD5E1',
  slab1: '#DCE2EB',
  slab2: '#E8ECF3',
  slab3: '#F4F6FA',
  slabWin: '#F7CF74',
  slabTrap: '#F9CBBC',

  dome: '#1B2740',
  domeGleam: '#94A2BC',

  p1: '#B23B00',
  p2: '#0E3E9B',

  mark: '#16203A',
  ink: '#10182C',
  tokenGlyph: '#F4F6FA',

  text: '#F2F5FB',
  textMuted: '#AFBBD6',
  gold: '#F0B93C',
  alarm: '#FF8A6B',
} as const;

/** Every surface a meaningful mark can be drawn on. */
export const SURFACES = ['slab0', 'slab1', 'slab2', 'slab3', 'slabWin', 'slabTrap'] as const;

/** Everything that must be findable on those surfaces. */
export const ON_BOARD = ['p1', 'p2', 'mark', 'dome', 'ink'] as const;

export const SEAT_COLOUR = [PALETTE.p1, PALETTE.p2];
export const SEAT_NAME = ['Ember', 'Cobalt'];
/** Silhouette, not just hue — the channel that survives any colour vision. */
export const SEAT_SHAPE = ['circle', 'triangle'];

export const TIER_FACE = [PALETTE.slab0, PALETTE.slab1, PALETTE.slab2, PALETTE.slab3];
